import React from "react";
import Logo from "./Logo";
import { Mail, Linkedin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      id="footer"
      data-testid="footer-section"
      className="bg-brand-deeper text-white pt-24 pb-12 border-t border-light-translucent"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* CTA banner */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-20 border-b border-light-translucent">
          <div className="md:col-span-7">
            <span className="overline text-[#2EC4B6]">— Let's design change</span>
            <h2
              className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.05] mt-4"
              data-testid="footer-cta-heading"
            >
              Have a problem worth<br />
              <span className="text-[#2EC4B6]">solving together?</span>
            </h2>
          </div>
          <div className="md:col-span-5 flex flex-col justify-end gap-5">
            <p className="text-white/60 text-base md:text-lg max-w-md">
              Tell us about your business, your ambitions or the change you can't
              quite name yet. We'll listen first.
            </p>
            <a
              href="mailto:administration@magis-company.com"
              data-testid="footer-email-cta"
              className="inline-flex items-center gap-3 px-7 py-4 bg-[#2EC4B6] text-[#0A2427] font-semibold w-fit hover:bg-white transition-colors duration-300"
            >
              <Mail size={18} />
              administration@magis-company.com
            </a>
          </div>
        </div>

        {/* Link grid */}
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8 py-16">
          <div className="col-span-2 md:col-span-4">
            <Logo variant="light" />
            <p className="text-white/50 text-sm leading-relaxed mt-6 max-w-xs">
              Strategic consulting designed in partnership. Operating from
              São Paulo, Turin and Brussels — expanding globally.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-[#2EC4B6] mb-4">Divisions</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#divisions" className="hover:text-[#2EC4B6] transition-colors">Strategy</a></li>
              <li><a href="#divisions" className="hover:text-[#2EC4B6] transition-colors">Innovation & Change</a></li>
              <li><a href="#divisions" className="hover:text-[#2EC4B6] transition-colors">Academy</a></li>
              <li><a href="#divisions" className="hover:text-[#2EC4B6] transition-colors">Pulse</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline text-[#2EC4B6] mb-4">Company</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#vision" className="hover:text-[#2EC4B6] transition-colors">Vision</a></li>
              <li><a href="#leadership" className="hover:text-[#2EC4B6] transition-colors">Team</a></li>
              <li><a href="#world" className="hover:text-[#2EC4B6] transition-colors">Global presence</a></li>
              <li><a href="#referrals" className="hover:text-[#2EC4B6] transition-colors">Voices</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-[#2EC4B6] mb-4">Offices</div>
            <ul className="space-y-4 text-sm text-white/70">
              <li>
                <div className="font-medium text-white">Magis Italia</div>
                <div className="text-white/50">VAT: 13355190011</div>
                <div className="text-white/50">Address: via Giovanni Servais 93/37 - Turin, Italy</div>
              </li>
              <li>
                <div className="font-medium text-white">Magis Belgium</div>
                <div className="text-white/50">VAT: 1031922226</div>
                <div className="text-white/50">Address: Rue D'Arlon 25, Ixelles, Belgium</div>
              </li>
              <li>
                <div className="font-medium text-white">Magis do Brasil</div>
                <div className="text-white/50">Sao Paolo, Brasil</div>
                <div className="text-white/50">Address: Ready soon</div>
              </li>
            </ul>
            <a
              href="https://www.linkedin.com/company/magis-group/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              aria-label="LinkedIn"
              className="inline-flex items-center gap-2 mt-6 text-sm text-white/70 hover:text-[#2EC4B6] transition-colors"
            >
              <Linkedin size={16} /> Follow on LinkedIn
            </a>
          </div>
        </div>

        {/* Watermark */}
        <div className="border-t border-light-translucent pt-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div className="text-xs text-white/40">
            © {new Date().getFullYear()} MAGIS Group. All rights reserved.
            &nbsp;·&nbsp; In partnership with PWT — Performance With Trust.
          </div>
          <div className="overline text-white/30">
            Change doesn't happen by itself.
          </div>
        </div>

        {/* Big watermark word */}
        <div
          aria-hidden="true"
          className="font-display text-[20vw] leading-none tracking-tighter text-white/[0.03] mt-10 select-none"
        >
          MAGIS
        </div>
      </div>
    </footer>
  );
};

export default Footer;
